export default __webpack_public_path__ + "static/media/loading-image.cfbea74f.png";